// Mobile navigation toggle functionality
function initMobileNav() {
	const mobileShowNav = document.getElementById('nav-mobile-toggle');
	const mainNav = document.getElementById('main-nav');
	const mobileNav = document.getElementById('mobile-nav');
	const body = document.body;

	if (!mobileShowNav) return;

	// Set initial aria-expanded state
	mobileShowNav.setAttribute('aria-expanded', 'false');

	// Mobile icon on click
	mobileShowNav.addEventListener('click', function () {
		// Check if nav is currently open
		const isOpen = body.classList.contains('nav-open');

		// Toggle the needed classes.
		body.classList.toggle('nav-open');
		mobileShowNav.classList.toggle('nav-open');
		mainNav.classList.toggle('nav-open');

		// Update aria-expanded based on new state
		mobileShowNav.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
	});


	// Close mobile nav when clicking outside
	document.addEventListener('click', function(e) {
		const isClickOnNav = mobileNav && mobileNav.contains(e.target);
		const isClickOnToggle = mobileShowNav.contains(e.target);

		if (!isClickOnNav && !isClickOnToggle && body.classList.contains('nav-open')) {
			body.classList.remove('nav-open');
			mobileShowNav.classList.remove('nav-open');
			mainNav.classList.remove('nav-open');
			mobileShowNav.setAttribute('aria-expanded', 'false');
		}
	});
}

window.addEventListener('DOMContentLoaded', initMobileNav);

function initMobileSubMenus(navContainer) {
	const parentMenuItems = navContainer.querySelectorAll('.menu-item-has-children');

	parentMenuItems.forEach(function(item) {
		const link = item.querySelector('a');

		if (link) {
			// Set initial aria-expanded for sub-menu toggles
			link.setAttribute('aria-expanded', 'false');

			link.addEventListener('click', function(e) {
				// Check if this is a submenu toggle (href="#")
				if (link.getAttribute('href') === '#') {
					e.preventDefault();
					e.stopPropagation();

					// Check if this submenu is currently open
					const isOpen = item.classList.contains('submenu-open');

					// Close all other open sub-menus and update their aria-expanded
					parentMenuItems.forEach(function(otherItem) {
						if (otherItem !== item) {
							otherItem.classList.remove('submenu-open');
							const otherLink = otherItem.querySelector('a');
							if (otherLink) {
								otherLink.setAttribute('aria-expanded', 'false');
							}
						}
					});

					// Toggle current sub-menu
					item.classList.toggle('submenu-open');

					// Update aria-expanded for current item
					link.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				}
			});
		}

		// Also allow clicking on the arrow area (right side of the item)
		item.addEventListener('click', function(e) {
			// Only trigger if clicking on the right side (arrow area)
			const rect = item.getBoundingClientRect();
			const clickX = e.clientX - rect.left;
			const itemWidth = rect.width;

			// If click is in the last 40px (arrow area)
			if (clickX > itemWidth - 40) {
				e.preventDefault();
				e.stopPropagation();

				const link = item.querySelector('a');
				const isOpen = item.classList.contains('submenu-open');

				// Close all other open sub-menus and update their aria-expanded
				parentMenuItems.forEach(function(otherItem) {
					if (otherItem !== item) {
						otherItem.classList.remove('submenu-open');
						const otherLink = otherItem.querySelector('a');
						if (otherLink) {
							otherLink.setAttribute('aria-expanded', 'false');
						}
					}
				});

				// Toggle current sub-menu
				item.classList.toggle('submenu-open');

				// Update aria-expanded for current item
				if (link) {
					link.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				}
			}
		});
	});

	// Close sub-menus when clicking outside
	document.addEventListener('click', function(e) {
		if (!e.target.closest('.menu-item-has-children')) {
			parentMenuItems.forEach(function(item) {
				item.classList.remove('submenu-open');
				const link = item.querySelector('a');
				if (link) {
					link.setAttribute('aria-expanded', 'false');
				}
			});
		}
	});
}

function initMobileSubmenusOnBreakpoint() {
	const mobileNav = document.querySelector('.mobile-nav');
	const mainNav = document.querySelector('.site-header__nav');

	if (mobileNav && window.innerWidth <= 1024) {
		initMobileSubMenus(mobileNav);
	}

	if (mainNav && window.innerWidth <= 1024) {
		initMobileSubMenus(mainNav);
	}
}

document.addEventListener('DOMContentLoaded', initMobileSubmenusOnBreakpoint);

// Reinitialize on responsive resize
window.addEventListener('responsiveResize', initMobileSubmenusOnBreakpoint);
